import QuizGame from "@/components/QuizGame";

const Index = () => <QuizGame />;

export default Index;
